<template>
  <span
    class="sf-pad-h-1 sf-font-xs sf-layer-rounded sf-progress-percentage-label"
    v-bind="$attrs"
  >
    <slot />
  </span>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>

<style scoped>
.sf-progress-percentage-label {
  background: rgb(255 255 255 / 70%);
}
</style>
